import type * as ReactType from 'react';
import { createAsyncComponentWithReducer, PrivateDistributionList, getLogger } from '../../shared';
import type { Store } from 'redux';

export interface CreateEditPrivateDLProps {
    viewMode: 'create' | 'edit';
    currentList: PrivateDistributionList;
}

export const CreateEditPrivateDLAsync = createAsyncComponentWithReducer<CreateEditPrivateDLProps>(
    () =>
        import(
            /* webpackChunkName: "CreateEditPrivateDL" */ './createEditPrivateDlLazyIndex'
        ).catch(error => {
            // Loading js chuck has failed
            getLogger().log('ChuckLoadFailed', {
                component: 'createEditPrivateDL',
                error: error ? error.message : undefined,
            });
            return Promise.reject();
        })
) as ReactType.ComponentType<
    {
        store: Store<{}>;
    } & CreateEditPrivateDLProps
>;
